import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Subscription} from "rxjs";
import {Rma} from "../_Models/rma";
import {RmaStoreService} from "../_services/rma-store.service";
import {Stampa} from "../../Stampe/Models/Stampa";
import {ServerPaginationService} from "../../shared/_services/server-pagination.service";
import {RmaFilter} from "../_Models/rma-filter";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {RmaProdottoAddComponent} from "../rma-add/rma-prodotto-add.component";
import {RmaEditComponent} from "../rma-edit/rma-edit.component";
import {Permission} from "../../Login/_guards/Permission";
import { environment } from 'src/environments/environment';
import {AttivitaTaskEditComponent} from "../../task/Attivita/attivita-edit/attivita-task-edit.component";
import {Task} from "../../task/models/Task";
import {ApiRestService} from "../_services/api-rest.service";
import {NewsComponent} from "../../task/news/news.component";

@Component({
  selector: 'app-rma-list',
  templateUrl: './rma-list.component.html'
})
export class RmaListComponent implements OnInit, OnChanges {
  environment=environment
  subscriptions: Subscription = new Subscription();
  collectionSize = 0;
  page = 1;
  pageSize: number = 50;
  pagesizeserver = 4; // pagine da precaricare dal server
  newpagegenerated: number;
  List: Rma[] = [];
  stampe: Stampa[];
  @Input() Padre: number;
  @Output() PadreChange = new EventEmitter<number>();
  @Input() filtri: any = new RmaFilter(0,10,undefined,undefined,undefined);
  constructor(
    private RmaStore: RmaStoreService,
    private paginationService: ServerPaginationService,
    private modalService: NgbModal,
    public permission: Permission,
    private apiRestService: ApiRestService
    ) { }

  showLuogoIntervento(){
    return !this.List.every(x=> (!x.ritiro || !x.ritiro.indirizzo) && (!x.acquirente || !x.acquirente.indirizzo));
  }
  ngOnInit(): void {
    this.refreshTable(1);
    // this.subscriptions.add(this.RmaStore.$prodotti.subscribe(data=> {
    //   this.List = data?.data ?? [];
    //   this.collectionSize = data.total;
    //   this.stampe = data.stampe;
    // }));
  }
  ngOnChanges(changes: SimpleChanges) {
    if(changes && changes['Padre'] ) {
      this.refreshTable(1)
    }
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page) {
    this.filtri.page = (page - 1) / this.pagesizeserver +1;
    this.filtri.size = this.pagesizeserver * this.pageSize;
    this.filtri.periodo = false;
    this.filtri.padre = this.Padre;
    console.log("Filtri RMA: ", this.filtri)


    this.apiRestService.GetRmaList(this.filtri,undefined,undefined)
      .subscribe(data => {
        this.List = data?.data?.map(x=> {
          x['color'] = this.getRmaColor(x);
          return x;
        }) ?? [];
        this.collectionSize = data.total;
        this.stampe = data.stampe;
      })
    // this.RmaStore.getList(this.filtri);
  }
  private getRmaColor(rma:Rma): string{
    if(environment.TaskAddon['ColoriCalendario']){
      var color ;
      environment.TaskAddon['ColoriCalendario']?.forEach(colore =>{
        if( (colore?.fieldexist && rma[colore?.fieldexist]) ||
          (colore?.fieldnotexist && !rma[colore?.fieldnotexist]) ||
          (colore?.arrayEmpty && (!rma[colore?.arrayEmpty] || rma[colore?.arrayEmpty]?.length >= 0)) ||
          (colore?.arrayFull && rma[colore?.arrayFull]?.length>0))
          color = colore.colore;
      })
      return color;
    }
    if(rma.chiuso)
      return '#6DA447';
    if(rma.data_fine_effettiva)
      return '#F6BE30'
    if (rma.data_apertura_centro)
      return '#758fef'
    if(rma.assistenzaId)
      return '#50270A'
    return '#E95A3B'

  }
  add(){
    this.RmaStore.updateSelected(new Rma());
    const editmodal = this.modalService.open(RmaProdottoAddComponent,{
      centered: true,
      backdrop: 'static',
      size: 'xl',
    });
    (<RmaProdottoAddComponent>editmodal.componentInstance).onClose.subscribe(data=>{
      this.refreshTable(1);
    })
  }
  edit(item){
    this.RmaStore.updateSelected(item);
    console.log(item)
    if(item?.tipo == 'L' ){//attivita di laboratorio
      let editmodal = this.modalService.open(NewsComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<NewsComponent>editmodal.componentInstance).IsModal = true;
      (<NewsComponent>editmodal.componentInstance).DynamicFields = this.environment.TaskAddon['DynamicFields']?.find(x => x.type.toLocaleUpperCase() == "Z");
      (<NewsComponent>editmodal.componentInstance).Item = item ?? new Task();
      (<NewsComponent>editmodal.componentInstance).updated.subscribe(data=> {this.refreshTable(1)});
    }
    else if(this.environment.RmaAddOn.taskGenerico){//taskboard
      let editmodal = this.modalService.open(AttivitaTaskEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
      (<AttivitaTaskEditComponent>editmodal.componentInstance).IsModal = true;
      (<AttivitaTaskEditComponent>editmodal.componentInstance).Item = item ?? new Task();
      (<AttivitaTaskEditComponent>editmodal.componentInstance).updated.subscribe(data=> {this.refreshTable(1)});
    }
    else{ //rma
      const editmodal = this.modalService.open(RmaEditComponent, {
        centered: true,
        backdrop: 'static',
        size: 'xl',
      });
    (<RmaEditComponent>editmodal.componentInstance).IsModal = true;
    (<RmaEditComponent>editmodal.componentInstance).added.subscribe(data => {
    });
    (<RmaEditComponent>editmodal.componentInstance).updated.subscribe(data => {
      this.refreshTable(1)
    });
  }
  }
}
